<template>
	<div>
		<div class="head_order" :class="{ 'no-header': noHeader }">
			<div class="order_logo">
				<router-link to="/">
					<LOGO />
				</router-link>
			</div>
			<div class="mobile_only head_order_title">ביצוע הזמנה</div>
			<div class="backto_bt backto_bt-cart">
				<a href="javascript:void(0);" @click="goToCart()">
					בחזרה לעגלה
					<span>></span>
					<CART2 />
				</a>
			</div>
		</div>
		<section class="page_padd page_padd_m order-enter-bg">
			<div class="login_box">
				<div class="title_has_svg">
					<CARMELLA />
					<h2 class="title center">כבר נרשמתם לאתר?</h2>
					<div class="title_s title_s--green" v-if="message">{{message}}</div>
					<div class="title_s title_s--green" v-else>לביצוע הזמנה התחברו או המשיכו לקופה</div>
				</div>
				<div class="prod_details_tabs login_tabs">
					<div class="inline clearfix">
						<div
							class="right prod_details_tab login_tab"
							v-bind:class="{ highlight: currentStep == 'reg' }"
              v-if="!message"
						>
							<a href="javascript:void(0);" @click="changeLogStep('reg')">פעם ראשונה?</a>
						</div>
						<div
							class="right prod_details_tab login_tab"
							v-bind:class="{ highlight: currentStep == 'login' }"
						>
							<a href="javascript:void(0);" @click="changeLogStep('login')">כניסה לחשבון</a>
						</div>
					</div>
				</div>
				<div class="login_inner" v-if="!isAdmin">
					<div class="log-step-reg" v-if="currentStep == 'reg'">
						<div class="social-login" v-if="!inApp">
							<div class="title_s">הצטרפות לכרמלה באמצעות:</div>
							<div class="inline clearfix">
								<div class="right soc_bt soc_g ease">
									<a href="#" @click.prevent="googleLogin">
										Google
										<GOOGLE />
									</a>
								</div>
								<div class="right soc_bt soc_face ease">
									<a href="#" @click.prevent="facebookLogin">
										Facebook
										<FACEBOOK />
									</a>
								</div>
							</div>
							<div class="login_note">
								הצטרפות מהירה דרך רשתות חברתיות- קל, בטוח והכי חשוב- לא צריך לזכור סיסמה! (לא לדאוג,
								לעולם לא נפרסם משהו ללא הסכמתך)
							</div>
							<div class="row_or">
								<span>או</span>
							</div>
						</div>
						<div class="bt_green bt_green--big">
							<a class href="javascript:void(0);" @click="continueToCheckout">להמשך הזמנה</a>
						</div>
					</div>
					<div class="log-step-login" v-if="currentStep == 'login'">
						<login-form v-if="redirectTo" :redirectTo="redirectTo" />
						<login-form v-else />
					</div>
				</div>
				<div class="login_inner admin_inner" v-if="isAdmin">
					<vue-simple-suggest
						ref="userSearch"
						v-model="searchUser"
						:debounce="500"
						:list="findUsers"
						type="search"
						:class="{ proccessing: loadingUsers }"
						class="user_search_form"
						placeholder="חפש שם משתמש..."
						autocomplete="on"
						mode="input"
						value-attribute="id"
						display-attribute="name"
						:filter-by-query="false"
						:destyled="true"
					>
						<div slot="suggestion-item" slot-scope="{ suggestion }" :key="suggestion.id" class="custom">
							<div class="clearfix">
								<span class="right autoc_tx">
									<span class="pr_title"
										>{{ suggestion.name ? suggestion.name : "לא נמצאו תוצאות...." }} ({{
											suggestion.firstname
										}}
										{{ suggestion.lastname }})</span
									>
								</span>
							</div>
						</div>
					</vue-simple-suggest>
					<a href="#" @click.prevent="nextToCheckout">להמשך הזמנה</a>
					<a href="#" style="float: left" @click.prevent="nextToCheckoutNewUser">צור משתמש חדש</a>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	/** Vue Components */
	import Info from "../components/Checkout/Info";
	import Shipment from "../components/Checkout/Shipment";
	import Payment from "../components/Checkout/Payment";
	import LoginForm from "../components/Forms/LoginForm";
	import VueSimpleSuggest from "vue-simple-suggest/dist/cjs";
	import router from "../router";
	import store from "../store";
	/** SVG icons */
	import GOOGLE from "../assets/img/soc_g.svg";
	import FACEBOOK from "../assets/img/soc_face.svg";
	import LOGO from "../assets/img/logo.svg";
	import CART2 from "../assets/img/cart2.svg";
	import CARMELLA from "../assets/img/carmella.svg";
	import { mapState, mapActions, mapGetters } from "vuex";
	import axios from "axios";

	export default {
		store,
		data() {
			return {
				searchUser: "",
				cancellRequest: false,
				loadingUsers: false,
				checkoutUrl: this.$wpData.checkout_url,
				homeUrl: this.$wpData.home_url,
				stageComplete: 0,
				users: [],
				currentStep: "login",
				showScreen: this.$store.state.userLogged && !this.$store.state.isAdmin ? false : true,
				inApp: this.$store.state.inApp
			};
		},
		props: ["redirectTo", "noHeader", "message"],
		watch: {
			loadingUsers(value) {
				if (value) {
					this.$refs.userSearch.hideList();
				}
			}
		},
		mounted() {
			const product_for_google = this.cartForGoogle;
			sendCheckoutStep(product_for_google, 1, "Order Enter");
		},
		computed: {
			...mapState(["isAdmin", "cities", "city"]),
			...mapGetters(["cartForGoogle"])
		},
		methods: {
			changeLogStep(newStep) {
				this.currentStep = newStep;
			},
			continueToCheckout() {
				if (this.redirectTo) {
					this.$router.push(this.redirectTo);
				} else {
					this.$router.push("/checkout");
				}
			},
			nextToCheckout() {
				this.$store.commit("setOrderAs", this.$refs.userSearch.selected);
				//this.$store.commit("swapUsers");
				this.continueToCheckout();
			},
			nextToCheckoutNewUser() {
				var newUser = {
					firstname: "",
					lastname: "",
					email: "",
					phone: "",
					phonesec: "",
					city: "",
					street: "",
					house: "",
					floor: "",
					apart: "",
					code: "",
					address: "",
					name: "",
					regvia: "",
					alter_products: "",
					order_nobags: "0",
					order_comments2: "",
					subscribed: "",
					terms: "",
					paylater: false,
					newUser: true
				};

				this.$store.commit("setOrderAs", newUser);
				//this.$store.commit("swapUsers");
				this.continueToCheckout();
			},
			goToCart() {
				this.openCart();
			},
			openCart() {
				setTimeout(() => {
					$(".cart").fadeIn(100, function() {
						$("body").addClass("noscroll");
						$(".cart_in").animate(
							{
								left: 0
							},
							600
						);
					});
				}, 500);
				this.$router.push({ path: "/" });
			},
			googleLogin() {
				var _this = this;
				// Ideally the button should only show up after gapi.client.init finishes, so that this
				// handler won't be called before OAuth is initialized.
				gapi.auth2
					.getAuthInstance()
					.signIn()
					.then(res => {
						if (res) {
							let id_token = res.getAuthResponse().id_token;
							let form = new FormData();
							form.append("id_token", id_token);
							axios({
								method: "POST",
								url: homeUrl + "?googleReg",
								headers: {
									"X-Requested-With": "XMLHttpRequest"
								},
								data: form
							})
								.then(response => {
									if (response.data.success == "false") {
										_this.error = response.data.errorText;
										return;
									}
									if (response.data.success == "true") {
										_this.$store.commit("setUserInfo", response.data.userInfo);
										_this.$modal.hide("login-modal");
										if (_this.$route.name == "orderEnter") {
											_this.continueToCheckout();
										}
									}
								})
								.catch(e => console.log(e));
						}
					})
					.catch(e => {
						console.log(e);
					});
			},
			facebookLogin() {
				var _this = this;
				FB.login(
					function(response) {
						// Handle the response object, like in statusChangeCallback() in our demo
						// code.
						console.log(response.authResponse);
						let token = response.authResponse.accessToken;
						let userId = response.authResponse.userID;
						let form = new FormData();
						form.append("token", token);
						form.append("userID", userId);
						axios({
							method: "POST",
							url: homeUrl + "?facebookReg",
							headers: {
								"X-Requested-With": "XMLHttpRequest"
							},
							data: form
						})
							.then(res => {
								if (res.data.success == "false") {
									_this.error = res.data.errorText;
									return;
								}
								if (res.data.success == "true") {
									_this.$store.commit("setUserInfo", res.data.userInfo);
									_this.$modal.hide("login-modal");
									if (_this.$route.name == "orderEnter") {
										_this.continueToCheckout();
									}
								}
							})
							.catch(e => {
								console.log(e);
							});
					},
					{ scope: "email" }
				);
			},
			findUsers(value) {
				return new Promise((resolve, reject) => {
					this.loadingUsers = true;
					this.$ajax({
						method: "POST",
						url: homeUrl,
						params: {
							searchUsers: "",
							user: value
						}
					})
						.then(res => {
							this.loadingUsers = false;
							resolve(res.data);
						})
						.catch(e => reject(e));
				});
			}
		},
		components: {
			LOGO,
			GOOGLE,
			FACEBOOK,
			CART2,
			Info,
			Shipment,
			Payment,
			CARMELLA,
			LoginForm,
			VueSimpleSuggest
		}
	};
</script>

<style scoped>
	.admin_inner .vue-simple-suggest.designed .suggestions {
		top: calc(100% + -1px);
		max-width: 100%;
		width: 100%;
		-webkit-transform: translateX(-0%);
		transform: translateX(0%);
	}
	.no-header {
		display: none;
	}
	.login_inner {
		padding-bottom: 8rem;
	}
	.right.prod_details_tab.login_tab a {
		color: #213519;
	}
	.right.prod_details_tab.login_tab.highlight a {
		color: #1e824c;
		border-color: #1e824c;
	}
</style>
